export const SHOW_LEGENDS = 'SHOW_LEGENDS';
export const SET_LEGENDS_PERMA = 'SET_LEGENDS_PERMA';
export const SET_LEGENDS = 'SET_LEGENDS';

export const showLegends = show => {
  return {
    type: SHOW_LEGENDS,
    show
  };
};

export const setLegendsPerma = listLegends => {
  return {
    type: SET_LEGENDS_PERMA,
    listLegends
  };
};

export const setLegends = listLegends => {
  return {
    type: SET_LEGENDS,
    listLegends
  };
};